import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"arrow-left\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.807 14.989L19.7 9.096a1.667 1.667 0 10-2.357-2.357l-7.071 7.071a1.666 1.666 0 000 2.357l.01.01.013.014 7.071 7.07a1.667 1.667 0 102.357-2.356l-5.916-5.916z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol